module.exports = __webpack_public_path__ + "img/buenos_aires_parque_patricios.bcf9d1b5.jpg";